import React from "react";

// reactstrap components
import {
  Col,
  Row,
  CardBody,
  Card,
  Container,
  CardTitle,
} from "reactstrap";
// core components

function PresentationHeader() {
  return (
    <>
      <Container fluid>
        <Row>
          <Col className="px-0" md="10">
            <Card
              className="card-fashion page-header-image"
              style={{
                backgroundSize: "100% 100%",
                backgroundImage:
                  "url(" + require("assets/img/Notaria/fondoEncabezado.jpg") + ")",
              }}
            >
              <CardBody>
                <CardTitle className="text-left" tag="div">
                  <div className="rellax-text-container rellax-text">
                    <h1 className="title" data-rellax-speed="-1" 
                        style={{marginTop: "-300px", fontSize: "500%", color : "#bd0b0ed8"}}>
                      Notaría 2 de Floridablanca
                    </h1>
                  </div>
                </CardTitle>
              </CardBody>
            </Card>
          </Col>
          <Col className="px-0" md="2">
            <Card className="card-fashion arrow-left">
              <CardTitle tag="div">
                <h5 style={{ paddingTop: "270px" }}>
                  <i className="now-ui-icons tech_watch-time" style={{fontSize: "25px", color:"#bd0b0e"}}></i>
                  {/* <br></br>
                  <b>Lunes a Viernes</b>
                  <br></br>
                    7:30 AM - 12:15 PM,
                    <br></br>
                    2:00 PM - 6:00 PM
                  <br></br> */}

                  <br></br>
                  {/* <b style={{color:"#bd0b0e"}}>Nuevo horario desde el 2 de marzo:</b> */}
                  <br></br>

                  <b>Lunes a Jueves</b>
                  <br></br>
                    7:40 AM - 12:10 PM,
                    <br></br>
                    2:00 P.M - 6:00 PM
                  <br></br>
                  <br></br>
                  {/* <br></br> */}

                    <b>Viernes</b>
                  <br></br>
                    8:00 AM - 12:00 PM,
                    <br></br>
                    2:00 P.M - 6:00 PM
                  <br></br>
                  <br></br>
                  {/* <br></br> */}

                  <b>Sábados de turno</b>
                  <br></br>
                    8:00 AM - 12:00 PM
                  {/* <br></br> */}
                    {/* <br></br>
                    2, 16 y 30 de Mayo */}
                  {/* <br></br> */}
                  {/* Horario especial Semana Santa */}
                  {/* <span style={{ color: "#bd0b0e" }}>
                    <b>⚠ Miércoles 1 de Abril</b> 
                  </span>
                  <br />
                    8:00 AM - 1:00 PM
                  <br></br>
                    13 y 27 de Junio
                  <br></br>
                    11 y 25 de Julio
                  <br></br>
                    11 y 25 de Julio
                  <br></br>
                    8 y 22 de Agosto
                  <br></br>
                    5 y 19 de Septiembre
                    */}
                  <br></br>
                    3, 17 y 31 de Octubre
                  <br></br>
                    14 y 28 de Noviembre
                  {/*
                  <br></br>
                    12 y 26 de Diciembre */}
                  {/* <br></br> */}
                  <br></br>
                  {/* <b style={{color:"#bd0b0e"}}>Sábados</b>
                  <br></br>
                  Diciembre 27
                  <br></br>
                  <b style={{color:"#bd0b0e"}}>Excepciones</b>
                    <br></br>
                    <center>
                      <table class="tableizer-table">
                        <tbody>
                          <thead>
                            <center>
                              <tr>
                                <td><b>Enero 2<br></br>No Hay Servicio</b></td>
                              </tr>
                            </center>
                            <center>
                              <tr>
                                <td>Diciembre 24 y 31</td>
                              </tr>
                            </center>
                          </thead>
                        </tbody>
                      </table>
                    </center>
                    8:00 am - 12:00 pm */}
                  <a href="https://www.contadorvisitasgratis.com" title="contador de visitas web">
                  <img src="https://counter8.optistats.ovh/private/contadorvisitasgratis.php?c=9c9sys3q5mbfyudmpf5m1k29ym7fu3qy" border="0" title="contador de visitas web" alt="contador de visitas web"/></a>
                </h5>
              </CardTitle>
            </Card>
          </Col>
        </Row>
      </Container>
    </>
  );
}

export default PresentationHeader;
